(() => {
  const giftVariant = 55288633098577;
  const sprayProduct = 11098589528401;
  const root = window.Shopify?.routes?.root || '/';
  let queue = Promise.resolve();
  async function request(path, body) {
    const response = await fetch(root + path, body ? {
      method: 'POST', headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(body)
    } : {cache: 'no-store'});
    if (!response.ok) throw new Error('Gratis Tester: ' + response.status);
    return response.json();
  }
  function sections() {
    const result = ['cart-drawer', 'cart-icon-bubble'];
    for (const id of ['main-cart-items', 'main-cart-footer', 'cart-live-region-text']) {
      const element = document.getElementById(id);
      if (element) result.push(element.dataset.id || id);
    }
    return [...new Set(result)].slice(0, 5);
  }
  async function reconcile(ids) {
    let cart = await request('cart.js');
    const eligible = cart.items.some(item => item.product_id === sprayProduct && item.quantity > 0);
    const gifts = cart.items.filter(item => item.variant_id === giftVariant);
    if (eligible && gifts.length === 0) {
      await request('cart/add.js', {items: [{id: giftVariant, quantity: 1, properties: {_luxfuem_gift: 'raumspray'}}]});
    } else if (gifts.length) {
      const updates = {};
      gifts.forEach((item, index) => {updates[item.key] = eligible && index === 0 ? 1 : 0;});
      if (gifts.some(item => item.quantity !== updates[item.key])) {
        await request('cart/update.js', {updates});
      }
    }
    cart = await request('cart.js');
    const sectionIds = ids || sections();
    const response = await fetch(root + '?sections=' + encodeURIComponent(sectionIds.join(',')), {cache:'no-store'});
    if (response.ok) cart.sections = await response.json();
    return cart;
  }
  function sync(ids) {
    const pending = queue.then(() => reconcile(ids));
    queue = pending.catch(error => console.error(error));
    return pending;
  }
  window.luxfuemSyncGift = async (state, add = false) => {
    if (state.errors || state.status) return state;
    try {
      const cart = await sync(state.sections ? Object.keys(state.sections) : undefined);
      return add ? {...state, sections: cart.sections || state.sections} : {...state, ...cart, sections: cart.sections || state.sections};
    } catch (error) {
      console.error(error);
      return state;
    }
  };
  function render(cart) {
    if (!cart.sections) return;
    for (const [id, html] of Object.entries(cart.sections)) {
      if (!html) continue;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const selector = id === 'cart-drawer' ? '#CartDrawer' : '.shopify-section';
      const source = doc.querySelector(selector);
      const target = id === 'cart-drawer' ? document.getElementById('CartDrawer') : document.getElementById('shopify-section-' + id) || document.getElementById(id);
      if (source && target) target.innerHTML = source.innerHTML;
    }
    const drawer = document.querySelector('cart-drawer');
    drawer?.classList.toggle('is-empty', cart.item_count === 0);
    if (drawer) drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
  }
  document.addEventListener('DOMContentLoaded', () => {
    sync().then(render).catch(error => console.error(error));
  }, {once: true});
  document.addEventListener('submit', async event => {
    if (!event.submitter || event.submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = event.submitter;
    button.disabled = true;
    try {
      await sync();
      window.location.assign(root + 'checkout');
    } catch (error) {
      console.error(error);
      button.disabled = false;
    }
  }, true);
})();
